import api from './api'
import config from '@/services/config'

export default {
  login (username, password, extra) {
    console.log('logn', { username, authKey: password, ...extra })
    return api.post('auth/login', { username, authKey: password, ...extra })
  },

  request (username, returnUrl) {
    const url = `auth/request` + (returnUrl ? `?returnUrl=${returnUrl}` : '')

    return api.post(url, { username, isDebug: config.debug })
      .then(res => {
        if (config.debug) {
          console.log(res.data.authKey)
        }
        return res
      })
  },

  setToken (token) {
    api.setToken(token)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/auth.js